module.exports = __webpack_public_path__ + "img/available_rule.6b9f4598.jpeg";